import Axios from 'axios';

import { SET_CREATE_IS_VISIBLE, CLIENT_UPDATE_STATUS, GET_CLIENTS, SET_CLIENT_ID, REMOVE_CLIENT } from './constants';

import {
    setClientInfoSelectedState,
    setCompanyName,
    setClientInfoStreet,
    setClientInfoStreet2,
    setClientInfoZip,
    setClientInfoCity,
    setCountry,
} from './ClientInfo/actions';

import {
    setNameChange,
    setLastNameChange,
    setPhoneChange,
    setEmailChange,
    setPositionChange,
} from './Contact/actions';


export const setCreateIsVisible = isVisible => ({
    type: SET_CREATE_IS_VISIBLE,
    isVisible,
});
export const updateClientStatus = clientUpdateStatus => ({
    type: CLIENT_UPDATE_STATUS,
    clientUpdateStatus,
});
export const setClientList = clientsList => ({
    type: GET_CLIENTS,
    clientsList,
});
export const setClientId = clientId => ({
    type: SET_CLIENT_ID,
    clientId,
});
export const removeClient = id => ({
    type: REMOVE_CLIENT,
    id,
});

export const setClient = client => (dispatch) => {
    dispatch(setClientId(client.id));
    dispatch(setClientInfoSelectedState(client.address.state));
    dispatch(setCompanyName(client.companyName));
    dispatch(setClientInfoStreet(client.address.address1));
    dispatch(setClientInfoStreet2(client.address.address2));
    dispatch(setClientInfoZip(client.address.zipCode));
    dispatch(setClientInfoCity(client.address.city));
    dispatch(setCountry(client.address.country));
    dispatch(setNameChange(client.firstName));
    dispatch(setLastNameChange(client.lastName));
    dispatch(setPhoneChange(client.phoneNumber));
    dispatch(setEmailChange(client.email));
    dispatch(setPositionChange(client.position));
};


export const getClientsList = authToken => (dispatch) => {
    const optionAxios = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
    };
    Axios.get('v1/customers', optionAxios)
        .then((res) => {
            dispatch(setClientList(res.data));
            dispatch(setClientId(null));
        }).catch((err) => {
            dispatch(updateClientStatus(err));
        });
};


export const createClient = ({ inputs }, authToken) => (dispatch) => {
    const optionAxios = {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
    };
    const payload = {
        customer: {
            position: inputs.position,
            company_name: inputs.companyName,
            first_name: inputs.firstName,
            last_name: inputs.lastName,
            email: inputs.email,
            phone_number: `${inputs.phone}`,
            address_attributes: {
                address_1: inputs.address_attributes.street,
                address_2: inputs.address_attributes.street2,
                city: inputs.address_attributes.city,
                country: inputs.address_attributes.country,
                state: inputs.address_attributes.selectedState,
                zip_code: inputs.address_attributes.Zip,
            },
        },

    };
    Axios.post('v1/customer/add', payload, optionAxios)
        .then((res) => {
            dispatch(updateClientStatus(`Successfully Added ${res.data.companyName}, ${res.data.firstName} ${res.data.lastName} as a Client`));
            dispatch(getClientsList(authToken));
        }).catch(() => {
            dispatch(updateClientStatus('Client Was Not Saved - Please check inputs for accuracy and formatting.'));
        });
};



// WEBPACK FOOTER //
// ./src/containers/AddClient/actions.js